export const EVENT_URL = '/rest/event/analytics';
export const PPLX_TRACKING_ALLOWED = 'pplx.trackingAllowed';
export const LOGIN_SOURCE_PARAM = 'login-source';
//# sourceMappingURL=core.js.map